import { render } from "./2013.vue?vue&type=template&id=06fb12f2"
import script from "./2013.vue?vue&type=script&lang=js"
export * from "./2013.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__